// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1TxJG","head":"Table_head__2H9IQ","col":"Table_col__3DH0F"};